import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-itdcr-notes',
  templateUrl: './modal-itdcr-notes.component.html',
  styleUrl: './modal-itdcr-notes.component.scss'
})
export class ModalItdcrNotesComponent implements OnInit {
  @Input() itdcrNo!: string;
  @Input() itdcrNotes?: string;
  @Input() readOnly: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() theme: string = 'silver';

  notes: string = '';

  constructor() {
  }

  ngOnInit(): void {
    this.notes = this.itdcrNotes || '';
  }

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<string>();


  onCloseClick() {
    this.onClose.emit();
  }
  onSaveClick() {
    this.onSave.emit(this.notes);
  }

}
